import React from 'react';
import { StructuredText } from 'react-datocms';

import './styles.css'

function ContentQuote({ items })
{
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-24 max-w-7xl mx-auto pb-8 offerte">
      {items.map(item => (
        <div key={item.id} className={`relative flex flex-row justify-center`}>
          <div className="h-44 w-44 bg-blue rounded-full flex justify-center items-center">

            <span className="text-2xl text-white font-medium">
              <StructuredText data={item.text} />
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ContentQuote;